import React from "react";
import ReactDOM from "react-dom";

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    document.getElementById("modal").appendChild(this.el);
    document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.getElementById("modal").removeChild(this.el);
    document.body.style.overflow = "auto";
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default Modal;
